import classNames from "classnames";
import React from "react";

import styles from "./index.module.scss";

interface Props {
  headless?: boolean;
  status?: "default" | "disabled" | "error";
  hasValue?: boolean;
  isFocused?: boolean;
  label?: string;
  width?: string;
  alwaysShowLabel?: boolean;
}

class Input extends React.PureComponent<Props> {
  public render() {
    const {
      headless,
      hasValue,
      isFocused,
      label,
      status = "default",
      alwaysShowLabel = false,
      width = "100%",
    } = this.props;

    const shouldShowBorderLabel = Boolean(
      (isFocused || hasValue || alwaysShowLabel) && label,
    );

    const rootStyles = classNames(styles.root, {
      [styles.headless]: headless,
      [styles.focused]: isFocused,
      [styles.error]: status === "error",
      [styles.disabled]: status === "disabled",
    });

    return (
      <div className={rootStyles} style={{ width }}>
        <div className={classNames(styles.topBorder)}>
          <div
            className={classNames(
              status !== "disabled" && styles.borderStroke,
              styles.left,
            )}
          />
          {shouldShowBorderLabel && (
            <div className={styles.borderLabel}>{label}</div>
          )}
          <div
            className={classNames(
              status !== "disabled" && styles.borderStroke,
              styles.right,
            )}
          />
        </div>
        {this.props.children}
      </div>
    );
  }
}

export { Input };
